import { CTASection } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';

export default function AppCTASection() {
  const { t, lang } = useTranslation();
  const prefix = `/${lang}`;

  return (
    <CTASection
      headline={t.cta.headline}
      headlineHighlight={t.cta.headlineHighlight}
      button={t.cta.button}
      href={`${prefix}/early-access`}
      card={{
        title: t.cta.card.title,
        description: t.cta.card.description,
        link: t.cta.card.link,
        href: `${prefix}/pricing`,
      }}
    />
  );
}
